/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Today_Back_StreakInputs */

const en_us2_engagement_today_back_streak = /** @type {(inputs: Engagement_Today_Back_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good to have you back. Your streak is still standing.`)
};

const pt_br2_engagement_today_back_streak = /** @type {(inputs: Engagement_Today_Back_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que bom ter você de volta. Sua sequência continua de pé.`)
};

const es_419_engagement_today_back_streak = /** @type {(inputs: Engagement_Today_Back_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué bueno tenerte de vuelta. Tu racha sigue en pie.`)
};

const pt_pt2_engagement_today_back_streak = /** @type {(inputs: Engagement_Today_Back_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que bom ter-te de volta. A tua sequência continua de pé.`)
};

const fr_fr2_engagement_today_back_streak = /** @type {(inputs: Engagement_Today_Back_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content de te revoir. Ta série tient toujours.`)
};

const de_de2_engagement_today_back_streak = /** @type {(inputs: Engagement_Today_Back_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schön, dass du wieder da bist. Deine Serie steht noch.`)
};

const it_it2_engagement_today_back_streak = /** @type {(inputs: Engagement_Today_Back_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bentornato. La tua striscia è ancora intatta.`)
};

/**
* | output |
* | --- |
* | "Good to have you back. Your streak is still standing." |
*
* @param {Engagement_Today_Back_StreakInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_today_back_streak = /** @type {((inputs?: Engagement_Today_Back_StreakInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Today_Back_StreakInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_today_back_streak(inputs)
	if (locale === "es-419") return es_419_engagement_today_back_streak(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_today_back_streak(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_today_back_streak(inputs)
	if (locale === "de-DE") return de_de2_engagement_today_back_streak(inputs)
	if (locale === "it-IT") return it_it2_engagement_today_back_streak(inputs)
	return en_us2_engagement_today_back_streak(inputs)
});
export { engagement_today_back_streak as "engagement.today_back_streak" }